import React from "react";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Admin from "../layout/Admin";
import { canAccess } from "../../utils/access";

// Shown in place of a page the role cannot open. Redirecting instead could
// loop, since a role with no sections is sent home to /printer.
const NoAccess = () => (
	<Admin>
		<p className="my-6 text-sm text-gray-600 dark:text-gray-400">
			Танд энэ хуудсыг үзэх эрх байхгүй.
		</p>
	</Admin>
);

const PrivateRoute = ({
	component: Component,
	section,
	auth: { isAuthenticated, loading, user, userLoading },
	...rest
}) => (
	<Route
		{...rest}
		render={(props) => {
			if (!isAuthenticated && !loading) return <Redirect to="/" />;
			// The role is not known until the user loads, and the page must not
			// call its API before then
			if (userLoading || !user) return null;
			if (!canAccess(user, section)) return <NoAccess />;
			return <Component {...props} />;
		}}
	/>
);

PrivateRoute.propTypes = {
	section: PropTypes.string.isRequired,
	auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
	auth: state.auth,
});

export default connect(mapStateToProps)(PrivateRoute);
